/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Welcome_Suggestion_Summarize_ReportsInputs */



/**
* | output |
* | --- |
* | "Summarize a long PDF for me" |
*
* @param {Uno_Welcome_Suggestion_Summarize_ReportsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_welcome_suggestion_summarize_reports = /** @type {((inputs?: Uno_Welcome_Suggestion_Summarize_ReportsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Welcome_Suggestion_Summarize_ReportsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Fass mir ein langes PDF zusammen")
	return /** @type {LocalizedString} */ ("Summarize a long PDF for me")
});